<template>
  <div class="LeaseList">
    <ul class="list">
      <li class="table-title">
        <div>标题</div>
        <div>所在地</div>
        <div>队伍规模</div>
        <div>更新时间</div>
      </li>
      <li v-for="(list,index) in teamList"
          :key="index">
        <div class="listDiv ellipsis cursor hover_02"
             @click="goRentalDetails(list.id)"
             :title="list.title">{{list.title}}</div>
        <div class="listDiv ellipsis">{{list.areaname}}</div>
        <div class="listDiv">{{list.scale}}人</div>
        <div class="listDiv">
          <div class="width50">{{formatDate2(list.currentTime, list.refresh_time) }}</div>
          <div class="width140"></div>
        </div>
      </li>
    </ul>
    <div class="loading" v-if="loadingTrue">
      <div class="icon">
        <i class="el-icon-loading"></i>
      </div>
      <p>数据加载中</p>
    </div>
    <div class="noData" v-if="noTextData">
      <div class="noDataImg">
        <img src="@/static/img/cailiao.png" alt />
      </div>
      <p class="noText">暂无数据</p>
    </div>
  </div>
</template>
<script>
import { formatDate2 } from '@/filters'

export default {
  name: 'LeaseList',
  components: {},
  props: {
    teamList: {
      type: Array,
      required: true
    },
    loadingTrue: {
      type: Boolean,
      required: true
    },
    noTextData: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {}
  },
  computed: {},
  methods: {
    formatDate2,
    goRentalDetails (id) {
      this.$router.push({ path: `/constructionDetails/${id}` })
    }
  },
  watch: {},
  created () {},
  mounted () {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import "~@/styles/static-style";
/* 面包屑 */
.LeaseList {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  .loading {
    width: 100%;
    height: 80px;
    margin-bottom: 20px;
    .icon {
      width: 48px;
      margin: 0 auto;
      i {
        font-size: 48px;
        color: #1890e1;
      }
    }
    p {
      font-size: 16px;
      color: #333;
      text-align: center;
    }
  }
  ul.list {
    width: 100%;
    list-style-type: none;
    background: #ffffff;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.08);
    border: 1px solid #e4e7ed;
    box-sizing: border-box;
    border-radius: 0 0 4px 4px;
    .table-title {
      background-color: #fafafa;
      color: #000;
      font-weight: 500;
      font-size: 16px;
      > div {
        padding: 0 10px;
      }
    }
    > li {
      width: 100%;
      height: 54px;
      line-height: 54px;
      box-sizing: border-box;
      border-bottom: 1px solid #e3e8ed;
      display: flex;
      text-align: left;
      position: relative;
      .posiIcon {
        padding: 0 !important;
        position: absolute;
        width: 24px;
        height: 28px;
        top: -5px;
        left: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      > div {
        padding: 0 10px;
        box-sizing: border-box;
        &:nth-child(1) {
          width: 400px;
          padding-left: 20px;
        }
        &:nth-child(2) {
          width: 340px;
        }
        &:nth-child(3) {
          flex: 1;
        }
        &:nth-child(4) {
          width: 100px;
        }
        .examine {
          position: absolute;
          top: 12px;
          width: 100px;
          height: 35px;
          line-height: 35px;
          background: #ff542e;
          color: #ffffff;
          border-radius: 35px;
          cursor: pointer;
        }
      }
      div.listDiv {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
    }
    > li:first-of-type {
      // border-top: 2px solid #ff532e;
      // height: 80px;
      > div {
        font-size: 14px;
        font-family: MicrosoftYaHei;
        font-weight: 400;
        color: rgba(51, 51, 51, 1);
        // font-weight: bolder;
      }
    }
    > li:last-of-type {
      border: none;
    }
    > li:not(:first-of-type):hover {
      background: #f5f7fa;
    }
  }
  .noData {
    width: 100%;
    margin-bottom: 50px;
    background: #ffffff;
    padding-bottom: 50px;
    padding-top: 50px;
    border: 1px solid #e4e7ed;
    border-radius: 0 0 4px 4px;
    border-top: none;
    box-sizing: border-box;
    .noDataImg {
      width: 177px;
      margin: 0 auto 15px;
      img {
        width: 100%;
      }
    }
    .noText {
      text-align: center;
      font-size: 18px;
      color: #333;
    }
  }
}
.colorOrange {
  color: #ff542e !important;
}
.tc_5 {
  height: 5px;
}
</style>
